<template>
  <v-container fluid>
    <v-layout justify-center wrap pt-3>
      <v-flex md12>
        <material-card color="orange" title="Attestation for Multiple Accounts">
          <v-layout>
            <v-flex md12>
              <p>
                To start with bulk attestations, download and fill out all the required columns in the template file and upload it back on this page.<br />
                <a href="https://di53zjzskd0oh.cloudfront.net/AttestationBulkTemplate.csv" target="_blank">Click here to download the template</a>
              </p>
              <formMultipleUploads @setFiles="setFileData" :isMultiple="false"/>
            </v-flex>
          </v-layout>
          <v-progress-linear
            v-if="loadingAccountData"
            color="orange"
            indeterminate/>
          <v-data-table
            v-model="selected"
            :headers="bulkAttestationHeaders"
            :items="content.data"
            :pagination.sync="pagination"
            select-all
            item-key="Account_ID"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:items="props" >
              <tr :active="props.selected">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    color="orange"
                    hide-details
                  />
                </td>
                <td>{{ props.item['Account_ID'] }}</td>
              </tr>
            </template>
          </v-data-table>
          <v-btn v-if="selected.length > 0" @click="proceedToNextStep">Proceed with the Attestation</v-btn>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import Papa from 'papaparse'

export default {
  data: () => ({
    selected: [],
    file: '',
    content: [],
    parsed: false,
    searchInput: '',
    searchField: 'Acct_ID',
    searchColumns: [
      {
        text: 'Customer Name',
        value: 'Customer_Id'
      }
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0
    },
    showProceedButton: false,
    accountCheckbox: []
  }),
  computed: {
    ...mapState('user/attestation', ['bulkAttestationHeaders', 'attestationAccounts', 'loadingAccountData']),
    ...mapState('user/requestAws', ['newAwsAcctExistingClient'])
  },
  mounted () {
    let type = 'existing'
    this.$store.dispatch('user/requestAws/getCustomers', type)
  },
  methods: {
    setFileData (file) {
      let self = this
      console.log('FILE', file)
      let reader = new FileReader()
      reader.readAsText(file, 'UTF-8')
      reader.onload = (evt) => {
        console.log('RAW FILE ', evt.target.result)
        this.parseFile(evt.target.result)
        console.log('file data')
        console.log(this.content.data)
      }
    },
    parseFile (file) {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          this.content = results
          this.parsed = true
        }.bind(this)
      })
    },
    onAccountSearch () {
      console.log('search starts....')
      this.showProceedButton = false
      this.accountCheckbox.forEach((value, index) => {
        this.accountCheckbox[index] = false
      })
      let searchData = {
        type: this.searchField,
        value: this.searchInput
      }
      this.$store.state['user/attestation'].nextPaginationKey = null
      this.$store.state['user/attestation'].accountDataFilters[this.searchField] = this.searchInput
      this.$store.dispatch('user/attestation/searchAccount')
    },
    proceedToNextStep () {
      this.$router.push({ path: '/attestation/new' })
      this.$store.commit('user/attestation/setBulkRequest', this.selected)
      console.log(this.selected)
    }
  }
}
</script>

<style lang="scss" scoped>
.masterpayer-status-filter-checkbox {
  display: inline-block;
  flex: none;
}
</style>
